export default [
  {
    _tag: "CSidebarNavItem",
    name: "Dashboard",
    to: "/dashboard",
    icon: "cil-speedometer",
    badge: {
      color: "info",
      text: "NEW",
    },
  },
  // {
  //   _tag: 'CSidebarNavTitle',
  //   _children: ['Theme']
  // },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Colors',
  //   to: '/theme/colors',
  //   icon: 'cil-drop',
  // },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Typography',
  //   to: '/theme/typography',
  //   icon: 'cil-pencil',
  // },
  {
    _tag: "CSidebarNavTitle",
    _children: ["Menu"],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Lead Management",
    route: "/lead",
    icon: "cil-puzzle",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Lead List",
        to: "/lead",
      },
      {
        _tag: "CSidebarNavItem",
        name: " Sub Lead List",
        to: "/sublead",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Upload Lead",
        to: "/uploadlead",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Main Lead Status",
        to: "/mainleadstatus",
      },

      {
        _tag: "CSidebarNavItem",
        name: "Main Lead SubStatus",
        to: "/mainleadsubstatus",
      },

      {
        _tag: "CSidebarNavItem",
        name: "Source",
        to: "/source",
      },

      {
        _tag: "CSidebarNavItem",
        name: "SubSource",
        to: "/subsource",
      },

      {
        _tag: "CSidebarNavItem",
        name: "Sub Lead Status",
        to: "/subleadstatus",
      },

      {
        _tag: "CSidebarNavItem",
        name: "Sub Lead SubStatus",
        to: "/subleadsubstatus",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "User Management",
    route: "/buttons",
    icon: "cil-user",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "User List",
        to: "/users",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Role",
        to: "/role",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Permission",
        to: "/permission",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Permission Category",
        to: "/permission-category",
      },
    ],
  },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Charts',
  //   to: '/charts',
  //   icon: 'cil-chart-pie'
  // },
  {
    _tag: "CSidebarNavDropdown",
    name: "Vendor & Packs",
    route: "/icons",
    icon: "cil-star",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Vendor List",
        to: "/vendors",
      },
      {
        _tag: "CSidebarNavItem",
        name: "LD Pack",
        to: "/packs",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Dialer Management",
    route: "/dialer",
    icon: "cil-bell",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Dialer",
        to: "/dialer",
      },
      //     {
      //       _tag: 'CSidebarNavItem',
      //       name: 'Badges',
      //       to: '/notifications/badges',
      //     },
      //     {
      //       _tag: 'CSidebarNavItem',
      //       name: 'Modal',
      //       to: '/notifications/modals',
      //     },
      //     {
      //       _tag: 'CSidebarNavItem',
      //       name: 'Toaster',
      //       to: '/notifications/toaster'
      //     }
    ],
  },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Widgets',
  //   to: '/widgets',
  //   icon: 'cil-calculator',
  //   badge: {
  //     color: 'info',
  //     text: 'NEW',
  //   },
  // },
  // {
  //   _tag: 'CSidebarNavDivider'
  // },
  // {
  //   _tag: 'CSidebarNavTitle',
  //   _children: ['Extras'],
  // },
  {
    _tag: "CSidebarNavDropdown",
    name: "LD Management",
    route: "/ldlead",
    icon: "cil-star",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "LD Lead List",
        to: "/ldlead",
      },
      // {
      //   _tag: 'CSidebarNavItem',
      //   name: 'Register',
      //   to: '/register',
      // },
      // {
      //   _tag: 'CSidebarNavItem',
      //   name: 'Error 404',
      //   to: '/404',
      // },
      // {
      //   _tag: 'CSidebarNavItem',
      //   name: 'Error 500',
      //   to: '/500',
      // },
    ],
  },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Disabled',
  //   icon: 'cil-ban',
  //   badge: {
  //     color: 'secondary',
  //     text: 'NEW',
  //   },
  //   addLinkClass: 'c-disabled',
  //   'disabled': true
  // },
  // {
  //   _tag: 'CSidebarNavDivider',
  //   className: 'm-2'
  // },
  // {
  //   _tag: 'CSidebarNavTitle',
  //   _children: ['Labels']
  // },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Label danger',
  //   to: '',
  //   icon: {
  //     name: 'cil-star',
  //     className: 'text-danger'
  //   },
  //   label: true
  // },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Label info',
  //   to: '',
  //   icon: {
  //     name: 'cil-star',
  //     className: 'text-info'
  //   },
  //   label: true
  // },
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Label warning',
  //   to: '',
  //   icon: {
  //     name: 'cil-star',
  //     className: 'text-warning'
  //   },
  //   label: true
  // },
  // {
  //   _tag: 'CSidebarNavDivider',
  //   className: 'm-2'
  // }
  {
    _tag: "CSidebarNavDropdown",
    name: "Report",
    route: "/",
    icon: "cil-star",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Source Wise",
        to: "/ldreport",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Campaign Wise",
        to: "/ldreport",
      },
    ],
  },
];
